"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const tooltip_text_1 = require("@Const/tooltip-text");
const react_1 = __importDefault(require("react"));
const RoleTooltip = () => react_1.default.createElement(CustomToolTip_1.default, { place: 'top', type: '?', info: tooltip_text_1.TOOLTIP_TEXT.createWork.writerRole });
exports.default = RoleTooltip;
